import { Item } from './item';
import { ServiceHistoricalApi } from '../../api/models/historical';

export class ServiceHistorical
{
    serviceId: string;
    items: Item[];

    public static mapperFromApi (source: ServiceHistoricalApi): Item[]
    {
        return source.items.map(Item.mapperFromApi);
    }
}
